const Header = () => {
    return(
        <>
            <nav className="custom-container">
                <h1 className="text-3xl">Delica<span className="primary-color-text">cy</span></h1>
                <p className="">Find curated restaurants in Bengaluru</p>
            </nav>
        </>
    )
}

export default Header;